import { mapState } from 'vuex';
import GamePreviewMixin from './trainer/gamePreviewMixin';
import _ from 'lodash';
import FlashCardsPreviewMixin from './trainer/FlashCardsPreviewMixin';

const STATIC_MODE = 'static';

export default {
    mixins: [GamePreviewMixin, FlashCardsPreviewMixin],
    props: {
        progress: Object,
    },
    data() {
        return {
            operations: {
                divide: this.$i18n.t('progress.progress_preview_divide'),
                multiply: this.$i18n.t('progress.progress_preview_multiply'),
            },
            digitCapacity: {
                1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                6: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                7: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                8: this.$i18n.t('common.common_gameSetting_digitCapacity8'),
            },
            digitCapacityForNumbersGameMode: {
                2: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                3: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                4: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                5: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                6: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
            },
            couplesColumnTypes: {
                image: this.$i18n.t('couples.couples_view_images'),
                word: this.$i18n.t('couples.couples_view_word'),
                phrase: this.$i18n.t('couples.couples_view_phrase'),
            },
            scannerGameMode: {
                image: this.$i18n.t('trainer.trainer_gameFormSettingValue_image'),
                symbol: this.$i18n.t('trainer.trainer_gameFormSettingValue_symbol'),
                mixed: this.$i18n.tc('trainer.trainer_gameFormSettingValue_mixed', 0),
            },
            schulteGameModes: {
                direct: this.$i18n.t('trainer.trainer_gameFormSettingValue_direct'),
                reverse: this.$i18n.t('trainer.trainer_gameFormSettingValue_reverse'),
                mixed: this.$i18n.tc('trainer.trainer_gameFormSettingValue_mixed', 1),
            },
            textsGameModes: {
                static: this.$i18n.t('trainer.trainer_gameFormSettingValue_static'),
                disappear: this.$i18n.t('trainer.trainer_gameFormSettingValue_disappear'),
                appear: this.$i18n.t('trainer.trainer_gameFormSettingValue_appear'),
            },
            catchWordGameModes: {
                static: this.$i18n.t('trainer.trainer_gameFormSettingValue_static'),
                interactive: this.$i18n.t('trainer.trainer_gameFormSettingValue_interactive'),
            },
            matrixGameModes: {
                column: this.$i18n.t('trainer.trainer_gameFormSettingValue_column'),
                collectAll: this.$i18n.t('trainer.trainer_gameFormSettingValue_collectAll'),
            },
        };
    },
    methods: {
        getPunctuationMarksParameterString(parameters) {
            return (
                ' / ' +
                this.$i18n.t('trainer.trainer_gameFormSetting_category') +
                ': ' +
                this.$i18n.t(`trainer.trainer_gameFormSetting_${parameters.category}`) +
                ' / ' +
                this.$i18n.t('trainer.trainer_gameFormSetting_rule') +
                ': ' +
                this.$i18n.t(`trainer.trainer_gameFormSetting_${parameters.rule}`) +
                ' / ' +
                this.$i18n.t('trainer.trainer_gameFormSetting_showingCorrectAnswers') +
                ': ' +
                this.$i18n.t(
                    parameters.showingCorrectAnswers
                        ? 'trainer.trainer_gameFormSettingValue_onAbbreviated'
                        : 'trainer.trainer_gameFormSettingValue_offAbbreviated'
                )
            );
        },
        getTextsParameterString(parameters, statistics) {
            let string = ' / ' + this.textsGameModes[parameters.mode];
            if (parameters.textLabel) {
                string +=
                    ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_textLabel') + ': ' + parameters.textLabel;
            }
            if (parameters.mode === STATIC_MODE) {
                if (parameters.settings.endLetters) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_withoutEndLetters') +
                        ': ' +
                        parameters.settings.letters;
                }
                if (statistics?.readingSpeed) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameStatistics_ReadingSpeed', { speed: statistics.readingSpeed });
                }
                if (statistics?.understandingSpeed) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameStatistics_understandingSpeed', {
                            speed: statistics.understandingSpeed,
                        });
                }
                if (parameters.settings.centralLetters) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_withoutCentralLetters') +
                        ': ' +
                        parameters.settings.letters;
                }
                if (parameters.settings.withoutWord) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_withoutWord');
                }
                if (parameters.settings.withoutWord) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_withoutVowels');
                }
                if (parameters.settings.solidText) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_solidText');
                }
                if (parameters.settings.anagrams) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_amountOfAnagrams') +
                        ': ' +
                        parameters.settings.anagrams.label;
                } else if (parameters.settings.mirrorText) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSettings_amountOfMirrorWords') +
                        ': ' +
                        parameters.settings.mirrorText.label;
                } else if (parameters.settings.invertText) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_invertText');
                }
            } else {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWords') +
                    ': ' +
                    parameters.settings.words +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_speed') +
                    ': ' +
                    parameters.speed.value +
                    ' ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute');
            }
            return string;
        },
        getTime(seconds) {
            if (seconds === null) {
                return null;
            }
            return `${Math.floor(seconds / 60) >= 10 ? '' : '0'}${Math.floor(seconds / 60)}:${
                seconds % 60 >= 10 ? '' : '0'
            }${seconds % 60}`;
        },
        getExtraOperation(parameters) {
            if (typeof parameters.extraOperations === 'object' && parameters.extraOperations !== null) {
                return Object.keys(parameters.extraOperations).find(extraOperation => {
                    return (
                        parameters.extraOperations[extraOperation] === true ||
                        parameters.extraOperations[extraOperation].isChosen
                    );
                });
            }
            return false;
        },
        getExtraOperationTranslation(extraOperation) {
            switch (extraOperation) {
                case 'endsWithFiveSquare':
                    return 'А5²';
                case 'endsWithOneSquare':
                    return 'А1²';
                case 'endsWithNineSquare':
                    return 'А9²';
                case 'abCrossAc':
                    return this.$i18n.t('trainer.trainer_gameFormSetting_rule') + ' AB*AC';
                case 'rule101':
                    return this.$i18n.t('trainer.trainer_gameFormSetting_rule') + ' 101';
                case 'mirror':
                    return this.$i18n.t('trainer.trainer_gameFormSetting_mirror');
                default:
                    return extraOperation;
            }
        },
        getGameSettingsTitle(exercise) {
            let gameName = exercise.slug;
            let parameters = _.cloneDeep(exercise.parameters.default);
            let string = this.$i18n.t('common.common_gameName_' + _.camelCase(exercise.slug));
            if (gameName === 'Puzzle') {
                if (!_.isArray(parameters)) {
                    string += ' / ' + parameters.difficult.name;
                    string += '; ' + this.$i18n.t('common.common_gameName_' + _.camelCase(parameters.games[0].game));
                    gameName = parameters.games[0].game;
                    if (`user${exercise.userId}` in parameters.games[0].parameters) {
                        parameters = parameters.games[0].parameters['user' + exercise.userId];
                    } else {
                        parameters = _.cloneDeep(exercise.parameters.default.games[0].parameters.default);
                    }
                    return this.settingsString(gameName, parameters, string);
                } else {
                    string += parameters
                        .map((parameters, index) => {
                            let string = `\n ` + this.$i18n.t('timetable.timetable_buttonText_day') + ` ${index + 1} `;
                            string +=
                                '; ' + this.$i18n.t('common.common_gameName_' + _.camelCase(parameters.games[0].slug));
                            gameName += parameters.games[0].name;
                            let params = _.cloneDeep(parameters.games[0].parameters.default);
                            return this.settingsString(gameName, params, string);
                        })
                        .join(' ');
                    return string;
                }
            }
        },
        settingsString(gameName, parameters, string, statistics) {
            if (gameName === 'AssembleTheNumber') {
                if (parameters.infinityAmountOfExamples) {
                    string += '/' + this.$i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples');
                } else {
                    string +=
                        '/' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                        ': ' +
                        parameters.numOfExamples;
                }
                if (parameters.coloredNumbers) {
                    string += '/' + this.$i18n.t('trainer.trainer_gameFormSetting_coloredNumbers');
                }
                string += ' / ' + this.digitCapacity[+parameters.digitCapacity];
            }
            if (gameName === 'SynonymsReadingEn') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.partOfSpeech);
            }
            if (gameName === 'SequenceOfNumbers') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples;
                string += ' / ';
                string +=
                    parameters.mode === 'numbers'
                        ? this.$i18n.t('trainer.trainer_gameFormSetting_sequenceOfNumbersModeNumbers')
                        : this.$i18n.t('trainer.trainer_gameFormSetting_sequenceOfNumbersModeCharacters');
                string += ' / ' + parameters.tableSize + ' x ' + parameters.tableSize;
                string += ' / ';
                if (parameters.location.diagonally) {
                    string += this.$i18n.t('trainer.trainer_gameFormSetting_location-diagonally') + '; ';
                }
                if (parameters.location.horizontally) {
                    string += this.$i18n.t('trainer.trainer_gameFormSetting_location-horizontally') + '; ';
                }
                if (parameters.location.vertically) {
                    string += this.$i18n.t('trainer.trainer_gameFormSetting_location-vertically');
                }
                if (parameters.mode === 'characters') {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_difficulty') +
                        ': ' +
                        parameters.digitCapacity;
                    if (parameters.coloredNumbers) {
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_coloredCharacters');
                    }
                    if (parameters.crossing) {
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_crossing-characters');
                    }
                    if (parameters.countingCombinations) {
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_counting-combinations');
                    }
                } else {
                    string += ' / ' + this.digitCapacityForNumbersGameMode[parameters.digitCapacity];
                    if (parameters.coloredNumbers) {
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_coloredNumbers');
                    }
                    if (parameters.crossing) {
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_crossing-numbers');
                    }
                }
            }
            if (
                gameName === 'Couples' ||
                gameName === 'CouplesReadingEn' ||
                gameName === 'CouplesMemoryDevelopment' ||
                gameName === 'WhoIsWho'
            ) {
                gameName !== 'WhoIsWho'
                    ? (string +=
                          ' / ' +
                          this.couplesColumnTypes[parameters.leftColumn] +
                          ' x ' +
                          this.couplesColumnTypes[parameters.rightColumn])
                    : '';
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') +
                    ': ' +
                    parameters.amountOfPairs +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples;
            }
            if (gameName === 'Diada') {
                let action = parameters.options.multiplication ? 'multiplication' : 'division';
                if (parameters.options.withTime) {
                    string += ' / ' + this.$i18n.t('common.common_gameName_' + action + 'WithTime');
                    string +=
                        ' / ' +
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                        ': ' +
                        parameters.showTime +
                        ' ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                } else {
                    string += ' / ' + this.$i18n.t('common.common_gameName_' + action + 'WithoutTime');
                }
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_viewTypeLeft') +
                    ': ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.leftColumnExample);
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') +
                    ': ' +
                    parameters.amountOfPairs +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples;
            }
            if (gameName === 'Chains' || gameName === 'ChainsReadingEn') {
                string +=
                    ' / ' +
                    this.couplesColumnTypes[parameters.viewType] +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfLinks') +
                    ': ' +
                    parameters.amountOfLinks +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples;
            }
            if (gameName === 'ConnectThePuzzles') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.theme);
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWords') + ': ' + parameters.amountOfPairs;
            }
            if (gameName === 'Orthograph') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.category);
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.rule);
                if (parameters.rule === 'vocabularyWords') {
                    string += ' / ' + this.$i18n.t('battle.battle_battleForm_grades') + ': ';
                    string += parameters.chosenClasses
                        .map(obj => this.$i18n.t('trainer.trainer_gameFormSetting_' + `${obj}`))
                        .join('; ');
                    if (parameters.isChooseByAlphabetSettingEnabled) {
                        string += ' / ' + this.$i18n.tc('trainer.trainer_gameFormSetting_letters', 1) + ': ';
                        string += parameters.chosenLetters.map(obj => `${obj}`).join('; ');
                    }
                }
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.mode);
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_playbackSpeed') + ': ' + parameters.playbackSpeed;
            }
            if (gameName === 'ChainsBonusGame' || gameName === 'ChainsBonusGameWithTime') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_viewType') +
                    ': ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.imageType + 'Images') +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfLinks') +
                    ': ' +
                    parameters.amountOfLinks +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples;
            }
            if (gameName === 'TransferSyllables') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.theme);
                string += ' / ' + this.$i18n.t('trainer.trainer_gamePlayBox_tip') + ': ';
                string += parameters.isHintEnabled ? this.$i18n.t('progress.progress_preview_statusOn') : this.$i18n.t('progress.progress_preview_statusOf');
                string += ' / ' + this.$i18n.t('common.common_gameName_vocabularyWords') + ': ';
                string += parameters.difficultWords ? this.$i18n.t('progress.progress_preview_statusOn') : this.$i18n.t('progress.progress_preview_statusOf');
            }
            if (gameName === 'TransferSyllablesSchoolPreparing') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.theme);
                string += ' / ' + this.$i18n.t('trainer.trainer_gamePlayBox_tip') + ': ';
                string += parameters.isHintEnabled ? this.$i18n.t('progress.progress_preview_statusOn') : this.$i18n.t('progress.progress_preview_statusOf');
                string += ' / ' + this.$i18n.t('common.common_gameName_vocabularyWords') + ': ';
                string += parameters.difficultWords ? this.$i18n.t('progress.progress_preview_statusOn') : this.$i18n.t('progress.progress_preview_statusOf');
            }
            if (gameName === 'DivideItRight' && !parameters.timeLimit) {
                string +=
                    ' / ' + this.$i18n.t('progress.progress_preview_examples') + ': ' + parameters.amountOfExamples;
            }
            if (
                (gameName === 'ChooseItRight' ||
                gameName === 'VocabularyWordsRus' ||
                gameName === 'DivideUnstressedVowels' ||
                gameName === 'WordStructure' ||
                gameName === 'SentenceParsing' ||
                gameName === 'ParsingSentencePartsSpeech') &&
                !parameters.timeLimit
            ) {
                string +=
                    ' / ' + this.$i18n.t('progress.progress_preview_examples') + ': ' + parameters.amountOfExamples;
            }
            if (gameName === 'HardSoftConsonants') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.theme);
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_transcription') + ': ';
                string += parameters.isTranscriptionEnabled ? this.$i18n.t('progress.progress_preview_statusOn') : this.$i18n.t('progress.progress_preview_statusOf');
            }
            if (gameName === 'HardSoftConsonantsSchoolPreparing') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.theme);
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_transcription') + ': ';
                string += parameters.isTranscriptionEnabled ? this.$i18n.t('progress.progress_preview_statusOn') : this.$i18n.t('progress.progress_preview_statusOf');
            }
            if (gameName === 'TranscriptionInWord') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_class_' + parameters.theme);
            }
            if (gameName === 'Scanner') {
                string +=
                    ' / ' +
                    this.scannerGameMode[parameters.mode] +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfUnknowns') +
                    ': ' +
                    parameters.numOfUnknowns +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples;
            }
            if (gameName === 'Shutter' || gameName === 'ShutterOnline') {
                switch (parameters.mode) {
                    case 'wordColumn':
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeWordColumn') +
                            ' / ' +
                            parameters.selectedGroups.join(', ') +
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInColumn') +
                            ': ' +
                            parameters.amountOfItemsInColumn;
                        break;
                    case 'syllableColumn':
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeSyllableColumn') +
                            ' / ' +
                            parameters.selectedGroups.join(', ') +
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_amountOfSyllablesInColumn') +
                            ': ' +
                            parameters.amountOfItemsInColumn;
                        break;
                    case 'text':
                        if (parameters.textLabel) {
                            string +=
                                ' / ' +
                                this.$i18n.t('trainer.trainer_gameFormSetting_textLabel') +
                                ': ' +
                                parameters.textLabel;
                        }
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeText') +
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInColumn') +
                            ': ' +
                            parameters.amountOfWordsInRow;
                        break;
                }
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_shutterSpeed') +
                    ': ' +
                    parameters.shutterSpeed.value +
                    ' ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute');
                if (parameters.shutterSpeedIncrease) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_shutterSpeedIncrease');
                }
                if (parameters.invertedWords) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords');
                }
            }
            if (gameName === 'ShutterRussianLanguage') {
                switch (parameters.mode) {
                    case 'wordColumn':
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeWordColumn') +
                            ' / ' +
                            parameters.selectedGroups.join(', ') +
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInColumn') +
                            ': ' +
                            parameters.amountOfItemsInColumn;
                        break;
                    case 'syllableColumn':
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeSyllableColumn') +
                            ' / ' +
                            parameters.selectedGroups.join(', ') +
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_amountOfSyllablesInColumn') +
                            ': ' +
                            parameters.amountOfItemsInColumn;
                        break;
                    case 'text':
                        if (parameters.textLabel) {
                            string +=
                                ' / ' +
                                this.$i18n.t('trainer.trainer_gameFormSetting_textLabel') +
                                ': ' +
                                parameters.textLabel;
                        }
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_shutterModeText') +
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInColumn') +
                            ': ' +
                            parameters.amountOfWordsInRow;
                        break;
                }
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_shutterSpeed') +
                    ': ' +
                    parameters.shutterSpeed.value +
                    ' ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute');
                if (parameters.shutterSpeedIncrease) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_shutterSpeedIncrease');
                }
                if (parameters.invertedWords) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords');
                }
            }
            if (gameName === 'WordsField' || gameName === 'WordsFieldOnline' || gameName === 'WordsFieldReadingEn') {
                string +=
                    ' / ' +
                    parameters.selectedGroups.join(', ') +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfRows') +
                    ': ' +
                    parameters.amountOfRows +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWordsToRemember') +
                    ': ' +
                    parameters.amountOfWords;
                if (parameters.withTime) {
                    string += ' / ' + this.$i18n.t('common.common_gameName_wordsFieldWithTime');
                }
                if (parameters.invertedWords) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords');
                }
            }
            if (gameName === 'Anagrams' || gameName === 'AnagramsOnline') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWords') +
                    ': ' +
                    parameters.amountOfWords +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfLetters') +
                    ': ' +
                    this.rulesArrayToString(parameters.letters);
            }
            if (gameName === 'Texts' || gameName === 'TextsOnline') {
                if (parameters.length > 1) {
                    string += parameters
                        .map((parameters, index) => {
                            let string = `\n ` + this.$i18n.t('timetable.timetable_buttonText_day') + ` ${index + 1} `;
                            string += this.getTextsParameterString(parameters, statistics);
                            return string;
                        })
                        .join(' ');
                } else {
                    string += this.getTextsParameterString(parameters, statistics);
                }
            }
            if (gameName === 'PunctuationMarks') {
                if (parameters.length > 1) {
                    string += parameters
                        .map((parameters, index) => {
                            let string = `\n ` + this.$i18n.t('timetable.timetable_buttonText_day') + ` ${index + 1} `;
                            string += this.getPunctuationMarksParameterString(parameters, statistics);
                            return string;
                        })
                        .join(' ');
                } else {
                    string += this.getPunctuationMarksParameterString(parameters, statistics);
                }
            }
            if (gameName === 'LettersField' || gameName === 'LettersFieldOnline') {
                string +=
                    ' / ' +
                    parameters.selectedLetters.join(', ') +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfRows') +
                    ': ' +
                    parameters.amountOfRows;
                if (parameters.invertedLetters) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_invertedLetters');
                }
            }
            if (gameName === 'CatchWord' || gameName === 'CatchWordOnline' || gameName === 'CatchWordReadingEn') {
                string +=
                    ' / ' +
                    this.catchWordGameModes[parameters.mode] +
                    ' / ' +
                    this.$i18n.tc('trainer.trainer_gameFormSetting_' + parameters.viewType, 1);
                if (parameters.selectedGroups.length !== 0) {
                    string += ' / ' + parameters.selectedGroups.join('; ');
                }
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                    ': ' +
                    parameters.showTime +
                    ' ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                if (parameters.isSeries && parameters.mode === 'interactive') {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_numOfSeries') +
                        ': ' +
                        parameters.seriesAmount;
                }
                switch (parameters.viewType) {
                    case 'words':
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWords');
                        break;
                    case 'syllables':
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_amountOfSyllables');
                        break;
                    case 'letters':
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_amountOfLetters');
                        break;
                }
                string += ': ' + parameters.amountOfWords;
                if (parameters.mode === 'static') {
                    string +=
                        ' / ' +
                        this.$i18n.t('olympiads.olympiads_olympiadForm_timeForAnswer') +
                        ': ' +
                        parameters.timeForAnswer +
                        ' ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                }
                if (parameters.wordsMovement) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_movement', {
                            element: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.viewType),
                        }) +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated');
                }
                if (parameters.invertedWords) {
                    switch (parameters.viewType) {
                        case 'words':
                            string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords');
                            break;
                        case 'syllables':
                            string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_invertedSyllables');
                            break;
                        case 'letters':
                            string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_invertedLetters');
                            break;
                    }
                    string += ': ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated');
                }
                if (parameters.accentedWords && parameters.viewType === 'words') {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_accentedWords') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated');
                }
            }
            if (gameName === 'VisionField' || gameName === 'VisionFieldReadingEn') {
                string += ' / ' + this.$i18n.t('progress.progress_preview_examples') + ': ' + parameters.numOfExamples;
            }
            if (gameName === 'RevivedNumbers') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers') +
                    ': ' +
                    parameters.amountOfNumbers +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfOpenedFields') +
                    ': ' +
                    parameters.amountOfOpenedFields +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_repeatedNumbers') +
                    ': ' +
                    parameters.repeatedNumbers;
            }
            if (gameName === 'SecretsOfCicero') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_view') +
                    ': ' +
                    this.$i18n.t(`trainer.trainer_gameFormSetting_${parameters.type}`) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfItemsInTheRoom') +
                    ': ' +
                    parameters.amountOfItemsInTheRoom +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInChain') +
                    ': ' +
                    parameters.amountOfWordsInChain +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_inOrder') +
                    ': ';
                string += parameters.inOrder
                    ? this.$i18n.t('progress.progress_preview_statusOn')
                    : this.$i18n.t('progress.progress_preview_statusOf');
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_difficultWords') + ': ';
                string += parameters.difficultWords
                    ? this.$i18n.t('progress.progress_preview_statusOn')
                    : this.$i18n.t('progress.progress_preview_statusOf');
            }
            if (gameName === 'CorrectiveSamples' || gameName === 'CorrectiveSamplesWithTime') {
                if (parameters.withTime) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                        ': ' +
                        parameters.showTime +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
                }
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfRows') +
                    ': ' +
                    parameters.amountOfRows +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfElementsToRemember') +
                    ': ' +
                    parameters.amountOfItems +
                    ' / ' +
                    this.$i18n.t('support.support_createTicket_theme') +
                    ': ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.selectedTheme.theme);
            }
            if (gameName === 'Navigator') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfSteps') +
                    ': ' +
                    parameters.amountOfSteps +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_field') +
                    ': ';
                string += parameters.isFieldOpened
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_opened')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_closed');
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_portal') + ': ';
                string +=
                    parameters.portal === 0
                        ? this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated')
                        : parameters.portal;
            }
            if (gameName === 'Search') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_searchTopic') +
                    ': ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.searchTopic) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfRequired') +
                    ': ' +
                    parameters.numOfUnknowns +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_tableSize') +
                    ': ' +
                    parameters.tableSize +
                    ' x ' +
                    parameters.tableSize;
            }
            if (gameName === 'Classifications') {
                string +=
                    ' / ' +
                    this.$i18n.t('couples.couples_view_' + parameters.viewType) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_tableSize') +
                    ': ' +
                    parameters.difficult.amountOfRows +
                    ' x ' +
                    parameters.difficult.amountOfColumns;
            }
            if (gameName === 'Associations') {
                string +=
                    ' / ' +
                    this.$i18n.t('support.support_createTicket_theme') +
                    ': ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.topic) +
                    ' / ';
                string += this.$i18n.t('trainer.trainer_gameFormSetting_subTopics') + ': ';
                for (let i = 0; i < parameters.selectedSubTopics.length; i++) {
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.selectedSubTopics[i]) + '; ';
                }
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_tableSize') +
                    ': ' +
                    parameters.difficult.amountOfRows +
                    ' x ' +
                    parameters.difficult.amountOfColumns;
            }
            if (gameName === 'FourthOne') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_mode') +
                    ': ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.mode) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples;
                for (let k = 0; k < parameters.themes.length; k++) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_themesForExample', { example: k + 1 }) +
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.themes[k].first) +
                        ', ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.themes[k].second);
                }
            }
            if (gameName === 'DigitCouples') {
                let difficultiesArray = parameters.difficulties.map(difficult => {
                    switch (difficult) {
                        case 'equality':
                            return this.$i18n.t('trainer.trainer_gameFormSettingValue_equality');
                        case 'inequality':
                            return this.$i18n.t('trainer.trainer_gameFormSettingValue_inequality');
                        default:
                            return this.$i18n.t('trainer.trainer_gameFormSettingValue_numberComposition', {
                                n: +difficult,
                            });
                    }
                });
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') +
                    ': ' +
                    parameters.amountOfPairs +
                    ' / ';
                for (let k = 0; k < difficultiesArray.length; k++) {
                    string +=
                        (k === 0 ? this.$i18n.t('trainer.trainer_gameFormSetting_difficulty') + ': ' : '') +
                        difficultiesArray[k] +
                        (k !== difficultiesArray.length - 1 ? ', ' : '');
                }
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_viewTypeLeft') +
                    ': ' +
                    this.$i18n.t('couples.couples_view_' + parameters.leftColumn) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_viewTypeRight') +
                    ': ' +
                    this.$i18n.t('couples.couples_view_' + parameters.rightColumn);
            }
            if (gameName === 'EquationOnline') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_positionOfUndefined') +
                    ': ' +
                    this.$i18n.t('common.common_gameSetting_' + parameters.position) +
                    ' / ';
                if (parameters.amountOfExamples) {
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSetting_examples') +
                        ': ' +
                        parameters.amountOfExamples +
                        ' / ';
                } else if (parameters.timeLimit) {
                    let timeLimit =
                        parameters.timeLimit +
                        ' ' +
                        this.$i18n.tc('trainer.trainer_gamePreview_timeParamMinuteDeclination', parameters.timeLimit);
                    string += this.$i18n.t('trainer.trainer_gameFormSetting_timeLimit') + ': ' + timeLimit + ' / ';
                }
                string +=
                    this.$i18n.t('trainer.trainer_gameFormSetting_actions') + ': ' + parameters.amountOfActions + ' / ';
                if (parameters.amountOfUnknowns) {
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSetting_unknowns') +
                        ': ' +
                        parameters.amountOfUnknowns +
                        ' / ';
                }
                if (parameters.stayIn10) {
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSetting_stayIn', { x: 10 }) +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') +
                        ' / ';
                }
                if (parameters.stayIn20) {
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSetting_stayIn', { x: 20 }) +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') +
                        ' / ';
                }
                if (parameters.stayIn100) {
                    let stayIn100String = '';
                    if (parameters.position === 'inAnswer' && parameters.stayIn100) {
                        let str = parameters.withJumpThroughTenners
                            ? this.$i18n.t('trainer.trainer_gameFormSetting_withJump').toLowerCase()
                            : this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump').toLowerCase();
                        stayIn100String =
                            str + ' ' + this.$i18n.t('trainer.trainer_gameFormSetting_throwTenners').toLowerCase();
                    } else if (parameters.stayIn100) {
                        stayIn100String = this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated');
                    }
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSetting_stayIn', { x: 100 }) +
                        ' ' +
                        stayIn100String +
                        ' / ';
                }
                if (parameters.doubleDigits) {
                    let doubleDigitSetting = '';
                    if (parameters.doubleDigits) {
                        if (parameters.position === 'inAnswer' && parameters.plusSingleDigits) {
                            let str = '+ ' + this.$i18n.t('trainer.trainer_gameFormSetting_singleDigits').toLowerCase();
                            doubleDigitSetting = parameters.withSingleDigitsJump
                                ? str + ' ' + this.$i18n.t('trainer.trainer_gameFormSetting_withJump').toLowerCase()
                                : str + ' ' + this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump').toLowerCase();
                        } else if (parameters.plusSingleDigits) {
                            doubleDigitSetting =
                                '+ ' + this.$i18n.t('trainer.trainer_gameFormSetting_singleDigits').toLowerCase();
                        } else if (parameters.position === 'inAnswer' && parameters.plusRoundDoubleDigits) {
                            doubleDigitSetting =
                                '+ ' +
                                this.$i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits').toLowerCase() +
                                ' ' +
                                this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump').toLowerCase();
                        } else if (parameters.plusRoundDoubleDigits) {
                            doubleDigitSetting =
                                '+ ' + this.$i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits').toLowerCase();
                        }
                    }
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSetting_doubleDigits') +
                        ': ' +
                        doubleDigitSetting +
                        ' / ';
                }
                if (parameters.roundDoubleDigits) {
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') +
                        ' / ';
                }
                if (parameters.roundTripleDigits) {
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSetting_roundTripleDigits') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated');
                }
                string = string.split('');
                string.length = string.length - ' / '.length;
                string = string.join('');
            }
            if (gameName === 'VocabularyWords' || gameName === 'WordDrum') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_topics') + ' : ';
                parameters.themes.forEach(theme => {
                    string += this.$i18n.t(`trainer.trainer_gameFormSetting_${theme.value}`) + '; ';
                });
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') +
                    ': ' +
                    parameters.amountOfPairs +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gamePlayBox_tip') +
                    ': ' +
                    (parameters.isHintEnabled
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf')) +
                    '; ';
            }
            if (gameName === 'SoundCouples') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_viewTypeLeft') +
                    ': ' +
                    this.$i18n.t('couples.couples_view_' + parameters.leftColumn) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_viewTypeRight') +
                    ': ' +
                    this.$i18n.t('couples.couples_view_' + parameters.rightColumn) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_order') +
                    ': ' +
                    this.$i18n.t('couples.couples_view_' + parameters.rightColumn) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') +
                    ': ' +
                    parameters.amountOfPairs +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                    ': ' +
                    parameters.numOfExamples;
            }
            if (gameName === 'VocabularyMemo' || gameName === 'VocabularyMemoRus') {
                string +=
                    ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_mode') + ': ' + gameName === 'Memory'
                        ? this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.viewType + 's')
                        : '' +
                          ' / ' +
                          this.$i18n.t('trainer.trainer_gameFormSetting_tableSize') +
                          ': ' +
                          parameters.difficult.amountOfRows +
                          ' x ' +
                          parameters.difficult.amountOfColumns +
                          ' / ' +
                          this.$i18n.t('trainer.trainer_gameFormSetting_topics') +
                          ': ';
                string += this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.selectedItems.value);
            }
            if (gameName === 'Memory' || gameName === 'Memo' || gameName === 'MemoBonusGames') {
                string +=
                    ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_mode') + ': ' + gameName === 'Memory'
                        ? this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.viewType + 's')
                        : '' +
                          ' / ' +
                          this.$i18n.t('trainer.trainer_gameFormSetting_tableSize') +
                          ': ' +
                          parameters.difficult.amountOfRows +
                          ' x ' +
                          parameters.difficult.amountOfColumns +
                          ' / ' +
                          this.$i18n.t('trainer.trainer_gameFormSetting_topics') +
                          ': ';
                if (parameters.viewType === 'topic' || parameters.viewType === 'image') {
                    string += this.$i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.selectedItems);
                } else {
                    parameters.selectedItems.forEach(topic => {
                        string += this.$i18n.t('trainer.trainer_gameFormSettingValue_' + topic) + '; ';
                    });
                }
            }
            if (gameName === 'MemoryX') {
                string +=
                    ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_mode') + ': ' + gameName === 'Memory'
                        ? this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.viewType + 's')
                        : '' +
                          ' / ' +
                          this.$i18n.t('trainer.trainer_gameFormSetting_tableSize') +
                          ': ' +
                          parameters.difficult.amountOfRows +
                          ' x ' +
                          parameters.difficult.amountOfColumns +
                          ' / ' +
                          this.$i18n.t('trainer.trainer_gameFormSetting_operations') +
                          ': ';
                if (parameters.operations.multiply) {
                    string += this.$i18n.t('trainer.trainer_gameFormSetting_operationMultiply');
                } else {
                    string += this.$i18n.t('trainer.trainer_gameFormSetting_operationDivide');
                }
            }
            if (
                typeof parameters.difficult === 'number' &&
                gameName !== 'AssembleTheNumber' &&
                gameName !== 'Associations'
            ) {
                if (gameName === 'Schulte') {
                    string += ' / ';
                    string +=
                        parameters.amountOfTables === 1
                            ? this.$i18n.t('trainer.trainer_gameFormSettingValue_oneTable')
                            : this.$i18n.t('trainer.trainer_gameFormSettingValue_twoTables');
                }
                if (gameName === 'Schulte' || gameName === 'Navigator') {
                    string += ' / ' + parameters.difficult + ' x ' + parameters.difficult;
                } else {
                    string += ' / ' + this.getDifficultName(parameters.difficult);
                }
            } else if (
                parameters.difficult &&
                typeof parameters.difficult !== 'object' &&
                gameName !== 'AssembleTheNumber' &&
                gameName !== 'Alphabet'
            ) {
                if (gameName === 'Expressions') {
                    const operations = this.chosenExpressionsOperations(parameters);
                    const isAdditionOrSubtractionChosen = operations.includes('+') || operations.includes('-');
                    if (isAdditionOrSubtractionChosen) {
                        string += ' / ' + this.$i18n.t('common')[parameters.difficult];
                    }
                } else {
                    string += ' / ' + this.$i18n.t('common')[parameters.difficult];
                }
            }
            if (
                parameters.difficult &&
                parameters.difficult.name &&
                gameName !== 'NumericalNetwork' &&
                gameName !== 'Associations'
            ) {
                string += ' / ' + parameters.difficult.name;
            } else if (
                parameters.difficult &&
                typeof parameters.difficult === 'object' &&
                gameName !== 'Classifications' &&
                gameName !== 'Memory' &&
                gameName !== 'Memo' &&
                gameName !== 'MemoryX' &&
                gameName !== 'MemoBonusGames' &&
                gameName !== 'VocabularyMemo' &&
                gameName !== 'VocabularyMemoRus' &&
                gameName !== 'Associations' &&
                gameName !== 'Alphabet'
            ) {
                if (gameName === 'Matrix') {
                    string +=
                        ' / ' +
                        this.$i18n.t('progress.progress_preview_difficult') +
                        ': ' +
                        parameters.difficult.amountOfRows +
                        'x' +
                        parameters.difficult.amountOfColumns;
                } else if (gameName !== 'NumericalNetwork') {
                    string +=
                        ' / ' +
                        this.$i18n.t('progress.progress_preview_difficult') +
                        ': ' +
                        this.difficultyStringified(parameters.difficult);
                }
            }
            if (parameters.combining) {
                string += ' (' + this.$i18n.t('progress.progress_preview_combining') + ')';
            }
            if (gameName === 'Anzan' || gameName === 'AnzanWithTime') {
                string += ' / ' + this.$i18n.t('progress.progress_preview_answers');
                if (parameters.negativeAnswers && parameters.positiveAnswers) {
                    string += this.$i18n.t('progress.progress_preview_answersAny');
                } else if (parameters.positiveAnswers) {
                    string += this.$i18n.t('progress.progress_preview_answersOnlyPositive');
                } else if (parameters.negativeAnswers) {
                    string += this.$i18n.t('progress.progress_preview_answersOnlyNegative');
                }
            } else if (parameters.negativeAnswers) {
                string += ' / ' + this.$i18n.t('progress.progress_preview_negativeNumbers');
            }
            if (parameters.fractions && !gameName.match('MultiplicationAndDivision')) {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_fractions') +
                    ' (' +
                    parameters.fractionalPart +
                    ' ' +
                    this.$i18n.tc('progress.progress_preview_fractionsNumber', parameters.fractionalPart) +
                    ' ' +
                    this.$i18n.t('progress.progress_preview_fractionsPoint') +
                    ')';
            }
            if (gameName === 'MultiplicationAndDivision' && parameters.divMode) {
                string += '/' + this.$i18n.t(`trainer.trainer_gameFormSettingDivision_${parameters.divMode}`);
            }
            if (gameName === 'TabularMultiplication') {
                if (parameters.timeForAnswer != '-1') {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') +
                        `: ${parameters.timeForAnswer} ` +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                } else {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
                if (parameters.selfDivision) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_selfDivision') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_on');
                } else {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_selfDivision') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
                if (parameters.changingMultipliers) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_changingMultipliers') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_on');
                } else {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_changingMultipliers') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
                let operations = [];
                for (let key in parameters.operations) {
                    parameters.operations[key] && operations.push(key);
                }
                operations = operations
                    .map(field => this.$i18n.t(`trainer.trainer_gameFormSetting_operation${this.pascalCase(field)}`))
                    .join(', ');
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_operations') + ': ' + operations;
                if (parameters.dictation) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_dictation') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_on');
                } else {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_dictation') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
            }
            if (gameName === 'EquationMultiplication') {
                if (parameters.timeForAnswer != '-1') {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') +
                        `: ${parameters.timeForAnswer} ` +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                } else {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
                if (parameters.changingMultipliers) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_changingMultipliers') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_on');
                } else {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_changingMultipliers') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
                let operations = [];
                for (let key in parameters.operations) {
                    parameters.operations[key] && operations.push(key);
                }
                operations = operations
                    .map(field => this.$i18n.t(`trainer.trainer_gameFormSetting_operation${this.pascalCase(field)}`))
                    .join(', ');
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_operations') + ': ' + operations;
                if (parameters.dictation) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_dictation') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_on');
                } else {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_dictation') +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
            }
            if (gameName === 'RootsAndDegrees' || gameName === 'RootsAndSquares') {
                const operationTranslation = this.$i18n.t(
                    parameters.operations.exponentiation
                        ? 'trainer.trainer_gameFormSetting_operationExponentiation'
                        : 'trainer.trainer_gameFormSetting_operationRootExtraction'
                );

                string +=
                    ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_operations') + ': ' + operationTranslation;
            }
            if (gameName === 'MultiplicationAndDivision' && parameters.divMode) {
                string += '/' + this.$i18n.t(`trainer.trainer_gameFormSettingDivision_${parameters.divMode}`);
            }
            const extraOperation = this.getExtraOperation(parameters);
            if (extraOperation) {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_extraOperations') +
                    ': ' +
                    this.getExtraOperationTranslation(extraOperation);
            }
            if (parameters.mirror) {
                string += ' / ' + this.$i18n.t('progress.progress_preview_mirror');
            }
            if (parameters.roundNumbers) {
                string += ' / ' + this.$i18n.t('progress.progress_preview_roundNumbers');
            }
            if (
                gameName === 'MultiplicationAndDivision' &&
                ((parameters.fractions && parameters.fractions.left) ||
                    (parameters.fractions && parameters.fractions.right))
            ) {
                string += ' / ' + this.$i18n.t('progress.progress_preview_fractions') + ' (';
                if (parameters.fractions && parameters.fractions.left) {
                    string +=
                        this.$i18n.t('progress.progress_preview_fractionsLeft') +
                        ':' +
                        parameters.fractionalPart.left +
                        ' ' +
                        this.$i18n.tc('progress.progress_preview_fractionsNumber', parameters.fractionalPart.left) +
                        ' ' +
                        this.$i18n.t('progress.progress_preview_fractionsPoint');
                }
                if (parameters.fractions && parameters.fractions.left && parameters.fractions.right) {
                    string += ', ';
                }
                if (parameters.fractions && parameters.fractions.right) {
                    string +=
                        this.$i18n.t('progress.progress_preview_fractionsRight') +
                        ':' +
                        parameters.fractionalPart.right +
                        ' ' +
                        this.$i18n.tc('progress.progress_preview_fractionsNumber', parameters.fractionalPart.right) +
                        ' ' +
                        this.$i18n.t('progress.progress_preview_fractionsPoint');
                }
                string += ')';
            }
            if (parameters.remainder) {
                string +=
                    this.$i18n.t('trainer.trainer_gameFormSetting_remainder') +
                    ':' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_on');
            }
            if (parameters.numbers && parameters.numbers.length > 0) {
                string +=
                    ' / ' + this.$i18n.t('progress.progress_preview_numbers') + `: ${parameters.numbers.join(', ')} `;
                if ('tabulatedValue' in parameters) {
                    string +=
                        '/ ' +
                        this.$i18n.t('progress.progress_preview_tabularValue') +
                        `: ${
                            parameters.tabulatedValue
                                ? this.$i18n.t('progress.progress_preview_statusOn')
                                : this.$i18n.t('progress.progress_preview_statusOf')
                        }`;
                }
            }
            if (parameters.digitCapacity && gameName !== 'AssembleTheNumber') {
                let outputArray = [];
                for (let key in parameters.digitCapacity) {
                    this.digitCapacity[parameters.digitCapacity[key][0]] &&
                        outputArray.push(this.digitCapacity[parameters.digitCapacity[key][0]]);
                }
                outputArray.length > 0 && (string += ' / ' + outputArray.join(', '));
            }
            if (parameters.multDivDigitCapacity) {
                const operations = this.chosenExpressionsOperations(parameters);
                const isAdditionOrSubtractionChosen = operations.includes('+') || operations.includes('-');
                if (!isAdditionOrSubtractionChosen) {
                    const onlyDivisionChosen = operations.includes('÷') && operations.length === 1;
                    if (!onlyDivisionChosen) {
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_divisible') +
                            '(' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_multiplier') +
                            ')' +
                            ': ' +
                            parameters.multDivDigitCapacity.left
                                .map(capacity => this.digitCapacity[capacity])
                                .join(', ');
                    }
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_divider') +
                        '(' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_multiplier') +
                        ')' +
                        ': ' +
                        parameters.multDivDigitCapacity.right.map(capacity => this.digitCapacity[capacity]).join(', ');
                }
            }
            if (
                parameters.mode &&
                gameName !== 'Scanner' &&
                gameName !== 'Texts' &&
                gameName !== 'Shutter' &&
                gameName !== 'ShutterOnline' &&
                gameName !== 'ShutterRussianLanguage' &&
                gameName !== 'CatchWord' &&
                gameName !== 'VisionField' &&
                gameName !== 'VisionFieldReadingEn' &&
                gameName !== 'TextsOnline' &&
                gameName !== 'CatchWordOnline' &&
                gameName !== 'FourthOne' &&
                gameName !== 'RootsAndSquares' &&
                gameName !== 'SequenceOfNumbers' &&
                gameName !== 'Diada' &&
                gameName !== 'Orthograph'
            ) {
                if (typeof parameters.mode !== 'object') {
                    if (gameName === 'Schulte') {
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                            ': ' +
                            parameters.numOfExamples;
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_order') +
                            ': ' +
                            this.schulteGameModes[parameters.mode];
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_invertedTable') + ': ';
                        string += parameters.invertedTable
                            ? this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated')
                            : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
                        string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_redAndBlack') + ': ';
                        string += parameters.redAndBlack
                            ? this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated')
                            : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
                    } else if (gameName === 'Matrix') {
                        string +=
                            ' / ' +
                            this.$i18n.t('trainer.trainer_gameFormSetting_mode') +
                            ': ' +
                            this.matrixGameModes[parameters.mode];
                    } else if (gameName !== 'TabularMultiplication') {
                        string += ' / ' + this.getModeName(parameters.mode);
                    }
                } else {
                    let outputArray = [];
                    for (let key in parameters.mode) {
                        parameters.mode[key] && outputArray.push(this.operations[key]);
                    }
                    string +=
                        ' / ' + this.$i18n.t('progress.progress_preview_multiDivMode') + ': ' + outputArray.join(', ');
                }
            }
            if (gameName === 'NumericalNetwork' && parameters.difficult) {
                string += ' / ' + this.$i18n.t(`common.common_gameSetting_digitCapacity${parameters.difficult.value}`);
            }
            if (gameName === 'Alphabet') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_mode') + ': ' + this.$i18n.t(`trainer.trainer_gameFormSetting_${parameters.theme}`);
                string += ' / ' + this.$i18n.t('router.router_editGame') + ': ' + this.$i18n.t(`trainer.trainer_gameFormSetting_${parameters.difficult}`);
                string += ' / ' + this.$i18n.t(`trainer.trainer_gameFormSetting_amountOfWords`);
                string +=': ' + parameters.amountOfWords;
            }
            if (gameName === 'Alphabet') {
                string += ' / ' + this.$i18n.t('common.common_gameName_vocabularyWords') + ': ';
                string += parameters.difficultWords ? this.$i18n.t('progress.progress_preview_statusOn') : this.$i18n.t('progress.progress_preview_statusOf');
            }
            if (gameName === 'Memorize' && parameters.displaySpeed) {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_displaySpeed') +
                    ' ' +
                    parameters.displaySpeed +
                    'c';
            }
            if (
                (gameName === 'Couples' ||
                    gameName === 'CouplesReadingEn' ||
                    gameName === 'CouplesMemoryDevelopment' ||
                    gameName === 'WhoIsWho') &&
                parameters.withTime
            ) {
                gameName !== 'WhoIsWho'
                    ? (string += ' / ' + this.$i18n.t('common.common_gameName_couplesWithTime'))
                    : (string += ' / ' + this.$i18n.t('common.common_gameName_whoIsWhoWithTime'));
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_pairShowTime') +
                    ': ' +
                    parameters.showTime +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            }
            if ((gameName === 'Anagrams' || gameName === 'AnagramsOnline') && parameters.withTime) {
                string += ' / ' + this.$i18n.t('common.common_gameName_anagramsWithTime');
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                    ': ' +
                    parameters.showTime +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            }
            if (
                (gameName === 'Couples' ||
                    gameName === 'CouplesMemoryDevelopment' ||
                    gameName === 'CouplesReadingEn') &&
                (parameters.leftColumn === 'word' || parameters.rightColumn === 'word')
            ) {
                let value = parameters.difficultWords
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_difficultWords') + ': ' + value;
            }
            if (
                (gameName === 'Chains' ||
                    gameName === 'ChainsReadingEn' ||
                    gameName === 'ChainsBonusGame' ||
                    gameName === 'ChainsBonusGameWithTime') &&
                parameters.withTime
            ) {
                string += ' / ' + this.$i18n.t('common.common_gameName_chainsWithTime');
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_pairShowTime') +
                    ': ' +
                    parameters.showTime +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            }
            if ((gameName === 'Chains' || gameName === 'ChainsReadingEn') && parameters.viewType === 'word') {
                let value = parameters.difficultWords
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_difficultWords') + ': ' + value;
            }
            if (gameName === 'Scanner' && parameters.withTime) {
                string += ' / ' + this.$i18n.t('common.common_gameName_scannerWithTime');
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                    ': ' +
                    parameters.showTime +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            }
            if (gameName === 'Matrix' && parameters.withTime) {
                string += ' / ' + this.$i18n.t('common.common_gameName_matrixWithTime');
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                    ': ' +
                    parameters.showTime +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            }
            if (
                parameters.amountOfExamples &&
                gameName !== 'EquationOnline' &&
                gameName !== 'DivideItRight' &&
                gameName !== 'ChooseItRight' &&
                gameName !== 'DivideUnstressedVowels'&&
                gameName !== 'WordStructure' &&
                gameName !== 'SentenceParsing' &&
                gameName !== 'ParsingSentencePartsSpeech' &&
                gameName !== 'VocabularyWordsRus'
            ) {
                string +=
                    ' / ' + this.$i18n.t('progress.progress_preview_examples') + ': ' + parameters.amountOfExamples;
            }
            if (parameters.numberAmount) {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers') +
                    ': ' +
                    parameters.numberAmount;
            }
            if (parameters.bracketAmount) {
                const bracketAmount = parameters.bracketsEnabled ? parameters.bracketAmount : 0;
                string +=
                    ' / ' + this.$i18n.t('trainer.trainer_gameSetting_amountOfBracketPairs') + ': ' + bracketAmount;
            }
            if (gameName === 'Expressions') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_operations') +
                    ': ' +
                    this.chosenExpressionsOperations(parameters).join(', ');
            }
            if (gameName === 'ParsingSentencePartsSpeech') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_difficultyLevel') + ': ';
                parameters.selectedClass.forEach(obj => {
                    string += this.$i18n.t(`trainer.trainer_gameFormSetting_class_` + obj.value) + '; ';
                });

                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_elements') + ': ';
                parameters.selectedParts.forEach(obj => {
                    string += this.$i18n.t(`trainer.trainer_gameFormSetting_` + obj.value) + '; ';
                });
            }
            if (gameName === 'WordStructure') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_difficultyLevel') + ': ';
                parameters.selectedClass.forEach(obj => {
                    string += this.$i18n.t(`trainer.trainer_gameFormSetting_wordStructure_` + obj.value) + '; ';
                });

                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_elements') + ': ';
                parameters.selectedParts.forEach(obj => {
                    string += this.$i18n.t(`trainer.trainer_gameFormSetting_` + obj.value) + '; ';
                });
            }
            if (gameName === 'SentenceParsing') {
                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_difficultyLevel') + ': ';
                parameters.selectedClass.forEach(obj => {
                    string += this.$i18n.t(`trainer.trainer_gameFormSetting_` + obj.value) + '; ';
                });

                string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_elements') + ': ';
                parameters.selectedParts.forEach(obj => {
                    string += this.$i18n.t(`trainer.trainer_gameFormSetting_` + obj.value) + '; ';
                });
            }
            if (gameName === 'KeenEye' || gameName === 'KeenEyeBonusGames') {
                if (parameters.displaySpeed) {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_displaySpeed') +
                        ': ' +
                        parameters.displaySpeed +
                        'c';
                }
                if (parameters.selectedColors) {
                    string += ' / ' + this.$i18n.t('trainer.trainer_gameFormSetting_chosenColor') + ': ';
                    parameters.selectedColors.forEach(selectedColor => {
                        string += this.$i18n.t(`common.common_gameSetting_color` + selectedColor.name) + '; ';
                    });
                }
            }
            if (parameters.amountOfVariants) {
                string +=
                    ' / ' + this.$i18n.t('progress.progress_preview_variants') + ': ' + parameters.amountOfVariants;
            }
            if (parameters.amountOfActions && gameName !== 'EquationOnline') {
                string += ` (${parameters.amountOfActions})`;
            }
            if (parameters.timeLimit && gameName !== 'TabularMultiplication') {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_timeLimit') +
                    ': ' +
                    parameters.timeLimit +
                    this.$i18n.t('progress.progress_preview_timeLimitMinute');
            }
            if (
                parameters.withTime !== false &&
                parameters.speed &&
                gameName !== 'Texts' &&
                gameName !== 'TextsOnline'
            ) {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_speed') +
                    ': ' +
                    +parameters.speed.toFixed(2) +
                    this.$i18n.t('progress.progress_preview_speedSeconds');
            }
            if (parameters.isSpeedIncrease) {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_speedIncrease') +
                    ' ' +
                    parameters.speedUp +
                    this.$i18n.t('progress.progress_preview_speedSeconds') +
                    ' ' +
                    this.$i18n.t('progress.progress_preview_exampleCrossing') +
                    ' ' +
                    parameters.tasksForSpeedUp +
                    ' ' +
                    this.$i18n.tc('progress.progress_preview_complicationExamples', parameters.tasksForSpeedUp);
            }
            if (parameters.isComplication) {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_complication') +
                    ' ' +
                    parameters.complication +
                    ' ' +
                    this.$i18n.tc('progress.progress_preview_complicationActions', parameters.complication) +
                    ' ' +
                    this.$i18n.t('progress.progress_preview_exampleCrossing') +
                    ' ' +
                    parameters.tasksForComplication +
                    ' ' +
                    this.$i18n.tc('progress.progress_preview_complicationExamples', parameters.tasksForComplication);
            }
            if (parameters.simple && parameters.simple.length > 0 && gameName !== 'AdditionAndSubtractionMathMagic') {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_simple') +
                    ': ' +
                    this.rulesArrayToString(parameters.simple);
            }
            if (parameters.brothers && parameters.brothers.length > 0) {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_brothers') +
                    ': ' +
                    this.rulesArrayToString(parameters.brothers);
            }
            if (parameters.friends && parameters.friends.length > 0) {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_friends') +
                    ': ' +
                    this.rulesArrayToString(parameters.friends);
            }
            if (parameters.brothersAndFriends && parameters.brothersAndFriends.length > 0) {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_brothersFriends') +
                    ': ' +
                    this.rulesArrayToString(parameters.brothersAndFriends);
            }
            if (parameters.jumpOver) {
                string += ' / ' + this.$i18n.t('progress.progress_preview_jumpOver') + ': ' + parameters.jumpOver.value;
            }
            if (parameters.jumpOver50 || parameters.jumpOver100) {
                string += ' / ' + this.$i18n.t('progress.progress_preview_jumpOver');
            }
            if (parameters.jumpOver50 && parameters.jumpOver100) {
                string += ' 50, 100';
            } else if (parameters.jumpOver50) {
                string += ' 50';
            } else if (parameters.jumpOver100) {
                string += ' 100';
            }
            if (parameters.isSeries && gameName !== 'CatchWord' && gameName !== 'CatchWordOnline') {
                string +=
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_series') +
                    ': ' +
                    parameters.seriesAmount +
                    ' / ' +
                    this.$i18n.t('progress.progress_preview_seriesExamples') +
                    ': ' +
                    parameters.seriesExamples;
            } else if (parameters.amount) {
                string += ' / ' + this.$i18n.t('progress.progress_preview_examples') + ': ' + parameters.amount;
            }
            if (gameName === 'Loner' || gameName === 'LonerBonusGames') {
                let name =
                    parameters.itemsType.value === '2'
                        ? this.$i18n.t('trainer.trainer_items_type_couples')
                        : this.$i18n.t('trainer.trainer_items_type_triads');
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_typeOfExamples') +
                    ': ' +
                    name +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gamePlayBox_amount') +
                    ': ' +
                    parameters.initialItemsAmount +
                    ' / ';
                if (gameName === 'LonerBonusGames') {
                    string +=
                        this.$i18n.t('trainer.trainer_gameFormSetting_blackWhiteImages') +
                        ': ' +
                        (parameters.blackWhiteImages
                            ? this.$i18n.t('progress.progress_preview_statusOn')
                            : this.$i18n.t('progress.progress_preview_statusOf')) +
                        ' / ';
                }
                string +=
                    this.$i18n.t('trainer.trainer_gameFormSetting_complication') +
                    ': ' +
                    (parameters.complication
                        ? this.$i18n.t('trainer.trainer_gameFormSettingValue_on')
                        : this.$i18n.t('trainer.trainer_gameFormSettingValue_off'));
            }
            if (gameName === 'CosmoTour') {
                const displayedAmountOfPlanets = parameters.initialAmountOfPlanets
                    ? parameters.initialAmountOfPlanets
                    : parameters.amountOfPlanets;
                let name = '';
                if (parameters.type.value === 'digits') {
                    name = 'Цифры';
                }
                if (parameters.type.value === 'mixed') {
                    name = 'Смешанные';
                }
                if (parameters.type.value === 'colors') {
                    name = 'Цвета';
                }
                string +=
                    '/' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_typeOfExamples') +
                    ': ' +
                    name +
                    '/' +
                    this.$i18n.t('trainer.trainer_gamePlayBox_amount') +
                    ' планет' +
                    ':' +
                    displayedAmountOfPlanets +
                    '/' +
                    'Длительность игры' +
                    ':' +
                    parameters.gameDuration.value +
                    ' секунд' +
                    '/';
                if (parameters.complication.selected) {
                    string += 'Усложнение' + ':' + parameters.complication.steps;
                } else {
                    string += 'Усложнение' + ':' + this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
                string += '/' + 'Подсказка' + ':';
                if (parameters.tip) {
                    string += this.$i18n.t('trainer.trainer_gameFormSettingValue_on');
                } else {
                    string += this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
                string += '/' + this.$i18n.t('trainer.trainer_gameFormSetting_distractingPictures') + ':';
                if (parameters.distraction) {
                    string += this.$i18n.t('trainer.trainer_gameFormSettingValue_on');
                } else {
                    string += this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
                }
            }
            if (gameName === 'Chameleon') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                    ': ' +
                    parameters.showTime +
                    ' ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_movement', {
                        element: this.$i18n.tc('trainer.trainer_textForm_words', 0),
                    }) +
                    ': ' +
                    (parameters.wordsMovement
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_music') +
                    ': ' +
                    (parameters.isMusicOn
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_distractingPictures') +
                    ': ' +
                    (parameters.pictures
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
            }
            if (gameName === 'MentalDrawing') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_view') +
                    ': ' +
                    this.$i18n.tc(`trainer.trainer_gameFormSetting_${parameters.viewType}`, 1);
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                    ': ' +
                    parameters.showTime +
                    ' ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_simultaneously') +
                    ': ' +
                    (parameters.simultaneously
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_differentFigures') +
                    ': ' +
                    (parameters.differentFigures
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_music') +
                    ': ' +
                    (parameters.isMusicOn
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
            }
            if (gameName === 'HandsUp') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_view') +
                    ': ' +
                    this.$i18n.tc(`trainer.trainer_gameFormSetting_${parameters.viewType}`, 1);
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                    ': ' +
                    parameters.showTime +
                    ' ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_movement', {
                        element: this.$i18n.tc('trainer.trainer_gamePlayBox_letters', 0),
                    }) +
                    ': ' +
                    (parameters.wordsMovement
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_music') +
                    ': ' +
                    (parameters.isMusicOn
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_distractingPictures') +
                    ': ' +
                    (parameters.pictures
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
            }
            if (gameName === 'RepeatAfterMe') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_showTime') +
                    ': ' +
                    parameters.showTime +
                    ' ' +
                    this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_simultaneously') +
                    ': ' +
                    (parameters.simultaneously
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_differentFigures') +
                    ': ' +
                    (parameters.differentFigures
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_music') +
                    ': ' +
                    (parameters.isMusicOn
                        ? this.$i18n.t('progress.progress_preview_statusOn')
                        : this.$i18n.t('progress.progress_preview_statusOf'));
            }
            if (gameName === 'Scout') {
                parameters.examples.forEach(({ num, theme }) => {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                        ': ' +
                        num +
                        ', ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_themeForExample', { example: null }) +
                        ': ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_' + _.camelCase(theme.name));
                });
            }
            if (gameName === 'Alpari') {
                parameters.examples.forEach(({ num, operations, numbers }) => {
                    string +=
                        ' / ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_numOfExamples') +
                        ': ' +
                        num +
                        ', ' +
                        this.$i18n.t('trainer.trainer_gameFormSetting_operations') +
                        ': ';
                    if (operations.multiply) {
                        string += this.$i18n.t('trainer.trainer_gameFormSetting_operationMultiply');
                    } else {
                        string += this.$i18n.t('trainer.trainer_gameFormSetting_operationDivide');
                    }
                    string += ' , ' + this.$i18n.t('progress.progress_preview_numbers') + `: ${numbers.join(', ')} `;
                });
            }
            if (gameName === 'LettersSoundsSyllables') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_category_of_words') +
                    ': ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_class_' + parameters.class);
            }
            if (gameName === 'VoicedAndDeafConsonants') {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_mode') +
                    ': ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.firstMode) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_mode') +
                    ': ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_' + parameters.secondMode) +
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') +
                    ': ' +
                    parameters.amountOfPairs;
            }
            if (
                gameName === 'PartsOfSpeech' ||
                gameName === 'SortOneMany' ||
                gameName === 'GenericWords' ||
                gameName === 'VerbTenses'
            ) {
                string +=
                    ' / ' +
                    this.$i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') +
                    ': ' +
                    parameters.amountOfPairs;
            }
            return string;
        },
        chosenExpressionsOperations(params) {
            let operations = [];
            if (params.operations.add) {
                operations.push('+');
            }
            if (params.operations.subtract) {
                operations.push('-');
            }
            if (params.operations.multiply) {
                operations.push('×');
            }
            if (params.operations.divide) {
                operations.push('÷');
            }
            return operations;
        },
        pascalCase(word) {
            word = _.camelCase(word);
            return word.charAt(0).toUpperCase() + word.slice(1);
        },
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
        percent() {
            if (!this.progress.isCompleted) {
                return 0;
            }
            return this.progress.percent;
        },
        progressClass() {
            if (this.percent >= 90) {
                return 'points__positive';
            } else if (this.percent >= 50) {
                return 'points__warning';
            }
            return 'points__negative';
        },
        gameParametersStringField() {
            let gameName = this.progress.game;
            let statistics = this.progress.statistics;
            let parameters = _.cloneDeep(this.progress.parameters);
            let parametersForSet = parameters;
            let string = this.$i18n.t('common.common_gameName_' + _.camelCase(this.progress.game));
            if (gameName === 'Puzzle') {
                string += ' / ' + parameters.difficult.name;
                string += '; ' + this.$i18n.t('common.common_gameName_' + _.camelCase(parameters.games[0].game));
                gameName = parameters.games[0].game;
                parametersForSet = parameters.games[0].parameters.default;
                for (let key in parameters.games[0].parameters) {
                    if (
                        key !== 'default' &&
                        key.match(/[\d]*[\d]+/g).some(userId => +userId === this.progress.userId)
                    ) {
                        parametersForSet = parameters.games[0].parameters[key];
                    }
                }
            }
            return this.settingsString(gameName, parametersForSet, string, statistics);
        },
    },
};
